import { translate } from "app/filters/i18nFilter";
import { swSettings } from "app/common/services/swSettings";
import type { IconName } from "@similarweb/icons";
import { isLocked } from "app/common/services/pageClaims";

const isWebsitesLocked = false;

interface ITab {
    title: string;
    id: string;
    tooltip: string;
    icon: IconName;
    hookModal: string;
    isLocked: boolean;
    dataAutomation: string;
}

type TabsType = Record<string, ITab>;

export const tabList: TabsType = {
    websites: {
        get title() {
            return translate("research.market.builder.tab.websites");
        },
        id: "websites",
        get tooltip() {
            return translate("research.market.builder.tab.websites.tooltip");
        },
        icon: "globe",
        hookModal: "",
        isLocked: isWebsitesLocked,
        dataAutomation: "by-websites-tab",
    },
    industry: {
        get title() {
            return translate("research.market.builder.tab.industry");
        },
        id: "industry",
        get tooltip() {
            return translate("research.market.builder.tab.industry.tooltip");
        },
        icon: "market",
        hookModal: "MarketBuilderIndustryTab",
        get isLocked() {
            return isLocked(swSettings.components.BuilderIndustryTab);
        },
        dataAutomation: "by-industry-tab",
    },
};

export const getTabFromIndex = (tabIndex) => {
    const selectedTab = Object.keys(tabList)[tabIndex];
    return tabList[selectedTab];
};
